//  TODO SS-4918 Добавить тест для функции

export function isElementInParentViewport(element: Element) {
    const parent = element.parentElement;

    if (!parent) {
        return false;
    }

    const elemRect = element.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    return (
        elemRect.top >= parentRect.top &&
        elemRect.left >= parentRect.left &&
        elemRect.bottom <= parentRect.bottom &&
        elemRect.right <= parentRect.right
    );
}
